<a (click)="scrollToTop()" aria-label="Volver arriba">
    <i class='bx bx-chevron-up-circle bx-sm'></i>
    Inicio de pagina
</a>
